const normalizeText = (value) => {
  return String(value || '').trim();
};

export default normalizeText;
